import React from 'react';
import { Link } from 'react-router-dom';

import Icon from 'components/DesignSystem/Icon';
import { UPLOAD_GUIDE_TAB_URL } from 'helper/flux/about';
import { cssVar } from 'constants/theme';

import './index.scss';

// Mesmo convite do desktop (views/Flux/Upload/New), na linguagem visual do
// mobile: o conteudo das instrucoes vive so no PDF de Sobre > Estudos Upload.
export default function GuideCard() {
  return (
    <section className="upload-guide-card">
      <Icon iconType="pdf" color={cssVar('text-accent')} size="large" />

      <h2 className="upload-guide-title">
        Guia do Estudos Upload — smapR v1.4.1
      </h2>

      <p className="upload-guide-text">
        Formatos aceitos, exigências do arquivo zip, nomeação dos arquivos e exemplos
        prontos. O material completo fica em
        {' '}
        <b>Sobre › Estudos Upload</b>
        .
      </p>

      <Link to={UPLOAD_GUIDE_TAB_URL} className="upload-guide-link">
        Abrir o guia (PDF)
        <Icon iconType="right_arrow" color={cssVar('text-on-accent')} size="small" />
      </Link>
    </section>
  );
}
